/* 


@PRAKT


   _____________________________________________________________

   |
   | FORM BIRTHDATE
   |
   _____________________________________________________________
*/

// import gsap from 'gsap';
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// gsap.registerPlugin(ScrollToPlugin);

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class FormBirthdate {
    constructor() {        
        this.init();
        this.day_value;
        this.month_value;
        this.year_value;
    }

    init() {
        this.birthdate = document.querySelector( 'input#birthdate' );
        if( !this.birthdate ) return;
        this.day = document.querySelector( '#ContactForm-day' );
        this.month = document.querySelector( '#ContactForm-month' );
        this.year = document.querySelector( '#ContactForm-year' );
        this.listenUpdates();
    }

    listenUpdates() {
        this.day.addEventListener( 'change', () => {
            this.day_value = this.add2dec( this.day.value );
            this.day.value = this.day_value;
            this.setRequired();
            this.updateBirthdate();
        } );
        this.month.addEventListener( 'change', () => {
            this.month_value = this.add2dec( this.month.value );
            this.month.value = this.month_value;
            this.setRequired();
            this.updateBirthdate();
        } );
        this.year.addEventListener( 'change', () => {
            this.year_value = this.add2dec( this.year.value );
            this.year.value = this.year_value;
            this.setRequired();
            this.updateBirthdate();
        } );
    }

    updateBirthdate() {
        const date = `${ this.day_value }/${ this.month_value }/${ this.year_value }`;
        if( this.day_value != undefined && this.month_value != undefined && this.year_value != undefined ) this.birthdate.value = date;
        else this.birthdate.value = '';
    }

    add2dec( val_ ) {
        let val  = Number( val_ );
        if( val <= 9 && val != 0 ) val = `0${ val }`;
        else if( val == '' || val == 0 ) val = undefined;
        return val;
    }

    setRequired() {        
        if( this.day_value != '' || this.month_value != '' || this.year_value != '' ) {
            this.day.required = true;
            this.month.required = true;
            this.year.required = true;
            this.day.setAttribute( 'aria-required', 'true' );
            this.month.setAttribute( 'aria-required', 'true' );
            this.year.setAttribute( 'aria-required', 'true' );
        }
        if ( this.day_value == undefined && this.month_value == undefined && this.year_value == undefined ) {
            this.day.required = false;
            this.month.required = false;
            this.year.required = false;
            this.day.removeAttribute( 'aria-required' );
            this.month.removeAttribute( 'aria-required' );
            this.year.removeAttribute( 'aria-required' );
        }
    }
}